import Link from 'next/link'
import { ImageWithFallback } from '@/components/atoms/ImageWithFallback'
import { ProductDataType } from '@/interfaces/pages'
import './styles.scss'

interface ProductCardProps {
  product: ProductDataType['product']
  priority?: boolean
}

export const ProductCard = ({
  product,
  priority = false,
}: ProductCardProps) => {
  const isUnavailable = product.available === false

  return (
    <Link
      href={product.href}
      className={`product-card  ${product.new ? 'new' : 'used'}${
        isUnavailable ? ' product-card--unavailable' : ''
      }`}
    >
      <figure>
        {product.new && <span className={`product-card__badge`}>Novo</span>}
        {isUnavailable && (
          <span className="product-card__badge product-card__badge--unavailable">
            Fora de estoque
          </span>
        )}
        <ImageWithFallback
          src={product.image ?? ''}
          alt={product.name}
          width={product.width}
          height={product.height}
          priority={priority}
          fetchPriority={priority ? 'high' : 'auto'}
          sizes="(max-width: 480px) 95vw, (max-width: 768px) 45vw, (max-width: 1400px) 25vw, 23vw"
        />
      </figure>
      <div>
        <h3>{product.name}</h3>
      </div>
    </Link>
  )
}
